<template>
  <div>
    <rabbey-table-3
      ref="reportTable"
      :key="TableKey"
      show-summary
      :summary-method="getSummaries"
      :data="reportData"
      :columns="reportColumns"
      :actions="reportActions"
      :loading="reportDataLoading"
      @rtable-push-action="handleCommand"
    />

    <CalendarFinancesEventForm
      :key="1"
      ref="form"
      @close-event-dialog="closeEventDialog"
      :form="form"
      :submitMode="submitMode"
      :dialogFormVisible="dialogFormVisible"
      :currentlyChosenAgenda="currentlyChosenAgenda"
      :CurrentResponsableInfo="CurrentResponsableInfo"
      :disabllingEditionSerie="disabllingEditionSerie"
    />
  </div>
</template>

<script>
import {
  columns,
  actions
} from "@/components/fiances/reports/table/columns/PaymentAndInvoicingReportColumns";
import { formatterMoney } from "@/utils";
import CalendarFinancesEventForm from "@/components/calendar/CalendarFinancesEventForm";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "PaymentAndInvoicingReportTable",
  components: {
    CalendarFinancesEventForm
  },
  props: {
    TabSelected: {
      type: String,
      default: "",
      required: true
    },
    YearSelected: {
      type: Number,
      default: 0,
      required: false
    },
    MonthSelected: {
      type: Number,
      default: 0,
      required: false
    },
    PaymentTypeSelected: {
      type: Number,
      default: 0,
      required: false
    },
    PaymentSelected: {
      type: String,
      default: "",
      required: false
    },
    ExecutionSelected: {
      type: String,
      default: null,
      required: false
    },
    InvoiceType: {
      type: String,
      default: "",
      required: false
    },
    WeekSelected: {
      type: String,
      default: "",
      required: false
    }
  },
  data() {
    return {
      reportData: [],
      reportColumns: columns(this),
      reportActions: actions,
      reportDataLoading: false,
      dialogFormVisible: false,
      TableKey: 0,
      form: {
        title: "",
        description: "",
        allDay: true,
        paid: false,
        type: true,
        startDate: "",
        startTime: "",
        endDate: "",
        endDatePayment: "",
        amount: 0,
        endTime: "",
        agendaType: 0,
        color: "#F22727",
        Time: 2,
        minutesHours: "m",
        fixed: true,
        invoiceType: "",
        SerieGroup: null,
        editionSerie: ""
      },
      submitModeOptions: {
        Add: "Agregar Facturación y Fecha de Pago",
        Edit: "Editar Fecha de Facturación",
        AddPayment: "Agregar Fecha de Pago",
        EditPayment: "Editar Fecha de Pago"
      },
      submitMode: "",
      currentlyChosenAgenda: {},
      CurrentResponsableInfo: {},
      invoiceType: "",
      disabllingEditionSerie: false
    };
  },
  async created() {
    this.employeeId = this.currentUser.EmployeeId;
    await this.GetPersonalCalendario({
      employeeID: this.employeeId,
      invoiceType: this.invoiceType
    });
  },
  // mounted() {
  //   this.GetReportData();
  // },
  computed: {
    ...mapGetters("calendarFinances", [
      "events",
      "weekendsVisible",
      "eventsAreLoading",
      "tasksAreLoading",
      "getCalendarFPsInfo"
    ]),
    ActualTabValue() {
      return this.TabSelected;
    },
    YearFilter() {
      return this.YearSelected;
    },
    MonthFilter() {
      return this.MonthSelected;
    },
    PaymentTypeFilter() {
      return this.PaymentTypeSelected;
    },
    PaymenFilter() {
      return this.PaymentSelected;
    },
    ExecutionFilter() {
      return this.ExecutionSelected;
    },
    InvoiceTypeFilter() {
      return this.InvoiceType;
    },
    WeekSelectedFilter() {
      return this.WeekSelected;
    }
  },
  methods: {
    ...mapActions("calendarFinances", [
      "create",
      "update",
      "set_weekends_visible",
      "GetPersonalCalendario",
      "initTasks",
      "updateTaskInApi",
      "delete",
      "getAllCalendarsForEmployee",
      "GetCalendario",
      "CreateCalendario",
      "DeleteCalendario"
    ]),
    formatterMoney,
    async GetReportData() {
      this.reportDataLoading = true;

      const body = {
        params: {
          Year: this.YearFilter,
          Month: this.MonthFilter,
          PaymentName: this.PaymenFilter,
          PaymentType: this.PaymentTypeFilter,
          isExecuted: this.ExecutionFilter,
          invoiceType: this.InvoiceTypeFilter,
          WeekSelected: this.WeekSelectedFilter
        }
      };

      await this.$http
        .get("/api/CalendarioFinanza/GetInvoicesAndPaymentsReport", body)
        .then((resp) => {
          this.reportColumns = columns(this);
          this.reportData = resp.data;
          this.TableKey += 1; // Force re-render of the table
          // this.reportColumns =  columns(this);
          this.$refs.reportTable.doLayout();

          this.$emit("InvociesAndPaymentData", resp.data);
        })
        .catch((err) => {
          this.$message.error(err);
        })
        .finally(() => {
          this.reportDataLoading = false;
        });
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Total por Mes";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));

        if (!values.every((value) => isNaN(value))) {
          let valor = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = this.formatterMoney(valor);
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },
    handleCommand(action) {
      if (action.command === "edit") {
        this.disabllingEditionSerie = true;
        this.dialogFormVisible = true;
      }
    },
    // OpenDialodDetailList(row, column) {

    //   // this.GetSelectedAgenda(row[`${column.property}_Id`]);
    //   this.dialogFormVisible = true;
    // },
    async closeEventDialog() {
      this.disabllingEditionSerie = false;
      this.dialogFormVisible = false;
      this.form = {
        title: "",
        description: "",
        allDay: false,
        paid: false,
        type: false,
        startDate: "",
        startTime: "",
        endDate: "",
        endDatePayment: "",
        amount: 0,
        endTime: "",
        color: "#F56C6C",
        agendaType: 0,
        Time: 2,
        minutesHours: "m",
        fixed: true,
        invoiceType: ""
      };
      await this.GetReportData();
    },
    async GetSelectedAgenda(agendaId) {
      try {
        await this.$http
          .get(`/api/CalendarFinances/GetAgendaById`, {
            params: {
              AgendaId: agendaId
            }
          })
          .then((resp) => {
            let agenda = resp.data;
            this.currentlyChosenAgenda = resp.data;
            this.form = {
              title: agenda.Title,
              description: agenda.Description,
              allDay: agenda.AllDay,
              paid: agenda.Paid,
              editionSerie: true,
              type: true,
              startDate: agenda.StarDate,
              startTime: agenda.StartTime,
              endDate: agenda.EndDate, // "end" was being returned as null so a new endDate prop is being used
              endDatePayment: agenda.EndDate,
              amount: agenda.Amount,
              endTime: agenda.EndTime,
              color: agenda.Color,
              agendaType: agenda.AgendaType,
              Time: agenda.TimeEstimated ?? 2,
              minutesHours: "m",
              fixed: agenda.IsFixed,
              invoiceType: agenda.invoiceType,
              SerieGroup: agenda.SerieGroup
            };

            this.CurrentResponsableInfo = this.getCalendarFPsInfo?.Employee;

            this.submitMode = this.submitModeOptions.Edit;
          })
          .catch((err) => {
            this.$message.error("Error al obtener la agenda: " + err);
          });
      } catch (error) {
        console.error("Error fetching agenda:", error);
        this.$message.error("Error al obtener la agenda: " + error);
      }
    },
    async ExcecutePayment(paymentId) {
      try {
        await this.$http
          .put(`/api/CalendarFinances/ExecutePayment`, paymentId)
          .then(async (resp) => {
            if (resp.data === false) {
              this.$message.error(
                "Error al ejecutar el pago: " + resp.statusText
              );
              return;
            } else if (resp.data === true) {
              this.$message.success("Pago ejecutado correctamente.");

              await this.GetReportData();
            } else {
              this.$message.error(
                "Error al ejecutar el pago: " + resp.statusText
              );
            }
          })
          .catch((err) => {
            this.$message.error("Error al ejecutar el pago: " + err);
          });
      } catch (error) {
        console.error("Error executing payment:", error);
        this.$message.error("Error al ejecutar el pago: " + error);
      }
    },
    async OnAmountActionClicked({ command, column, row }) {
      if (command === "execute") {
        await this.ExcecutePayment(row[`${column.property}_Id`]);
      } else if (command === "edit") {
        this.disabllingEditionSerie = false;
        this.GetSelectedAgenda(row[`${column.property}_Id`]);
        this.dialogFormVisible = true;
      } else {
        console.error("Unknown command:", command);
      }
    }
  },
  watch: {
    ActualTabValue(val) {
      if (val === "report") this.GetReportData();
    },
    YearFilter() {
      this.GetReportData();
    },
    MonthFilter() {
      this.GetReportData();
    },
    PaymentTypeFilter() {
      this.GetReportData();
    },
    ExecutionFilter() {
      this.GetReportData();
    },
    InvoiceTypeFilter() {
      this.GetReportData();
    },
    WeekSelectedFilter() {
      this.GetReportData();
    },
    PaymenFilter() {
      this.GetReportData();
    }
  }
};
</script>

<style scoped></style>
